import { PageHeader } from "../components/PageHeader";

type LegalKind = "terms" | "privacy" | "children";

const CONTENT: Record<LegalKind, { title: string; intro: string; sections: Array<[string, string]> }> = {
  terms: {
    title: "用户协议",
    intro: "本协议适用于作业管家 H5。使用注册账号或快速体验功能，即表示你理解并接受以下规则。",
    sections: [
      ["1. 服务内容", "本产品提供孩子档案、作业录入、计划拆分、今日任务和完成报告。拍照识别、提醒等未明确上线的能力不构成当前承诺。"],
      ["2. 账号责任", "你应使用本人可控制的手机号作为账号名，妥善保管密码与恢复码，不得共享账号或利用服务处理违法、有害内容。"],
      ["3. 数据准确性", "计划结果依据你录入的数量和日期生成，仅用于家庭学习安排，不替代学校、教师或专业机构判断。"],
      ["4. 服务变更", "为安全、维护和法规要求，运营方可调整功能并尽量提前说明。重大变更会重新征求同意。"],
      ["5. 账号终止", "你可以在账号与安全页面注销账号。注销后孩子、作业、计划和完成记录会按界面说明永久删除。"],
    ],
  },
  privacy: {
    title: "隐私政策",
    intro: "我们遵循最少必要原则处理家庭作业管理所需数据，不出售孩子数据，不用于广告画像。",
    sections: [
      ["1. 收集的数据", "账号注册处理手机号、密码哈希、恢复码哈希和家长称呼；业务功能处理孩子昵称、年级、作业、计划和完成记录。首版不要求真实姓名、学校、身份证或精确位置。"],
      ["2. 使用目的", "数据仅用于登录恢复、账号安全、生成和展示作业计划、同步完成状态、排查故障与履行安全义务。"],
      ["3. 存储与安全", "业务数据存储于 MySQL；密码和恢复码使用加盐哈希；登录使用 HttpOnly Cookie；正式环境使用 HTTPS。"],
      ["4. 共享与第三方", "拍照识别由百度智能云 OCR 提供。仅当你主动拍照或上传时，压缩后的图片会通过加密连接发送至该服务完成文字识别；本应用不保存原图。核心业务数据不向广告平台出售。未来接入短信或推送供应商前，将更新第三方清单并按需要重新征求同意。"],
      ["5. 你的权利", "你可以查看和修改档案、删除孩子、修改密码、退出全部设备或注销账号。账号注销会触发关联业务数据级联删除。"],
      ["6. 联系方式", "客服及隐私联系：13190311434。也可扫描页面底部微信二维码联系我们。"],
    ],
  },
  children: {
    title: "儿童信息处理说明",
    intro: "孩子档案由家长或其他监护人创建和管理。请仅在获得适当监护授权后录入儿童相关信息。",
    sections: [
      ["1. 最少录入", "建议使用昵称而非真实姓名。年级用于展示和计划管理；不要在作业文本中录入身份证、住址、电话、健康状况等无关敏感信息。"],
      ["2. 监护人控制", "监护人可修改或删除孩子档案。删除孩子后，其作业、计划和完成记录同步删除，且无法恢复。"],
      ["3. 禁止用途", "儿童数据不用于行为广告、公开排名、画像交易或与核心作业管理无关的自动化决策。"],
      ["4. 第三方能力", "拍照识别使用百度智能云 OCR。图片仅在监护人主动操作后加密传输用于本次识别，本应用不保存原图；识别结果必须由用户校对后才能保存为作业。识别失败时可继续手动录入。"],
      ["5. 申诉与删除", "如发现信息录入错误或未经授权，应立即通过档案删除或账号注销功能处理，并联系正式运营方公布的隐私渠道。"],
    ],
  },
};

export function LegalPage({ kind }: { kind: LegalKind }) {
  const content = CONTENT[kind];
  const operatorName = import.meta.env.VITE_OPERATOR_NAME?.trim() || "优创享科技";
  const supportContact = "13190311434";
  return (
    <main className="legal-shell">
      <section className="screen legal-page">
        <PageHeader title={content.title} back />
        <p className="legal-date">生效日期：2026-07-17</p>
        <p className="legal-intro">{content.intro}</p>
        {content.sections.map(([title, text]) => <section key={title}><h2>{title}</h2><p>{text}</p></section>)}
        <section className="legal-support">
          <h2>客服与隐私联系</h2>
          <p>运营主体：{operatorName}<br />联系电话：<a href={`tel:${supportContact}`}>{supportContact}</a></p>
          {kind === "privacy" ? <><img src="/wechat-contact-qr.jpg" alt="客服微信二维码" /><small>使用微信扫码添加客服，可咨询产品或提交隐私问题。</small></> : null}
        </section>
      </section>
    </main>
  );
}
